import { arredondarValorTributo } from "../../../utils";

const CSOSN_COM_SUBSTITUICAO = ["201", "202", "203", "900"];

const temSubstituicao = (produto, nfSaida) =>
  (produto?.calculaIcmsSt &&
    CSOSN_COM_SUBSTITUICAO.includes(produto?.tributosIcmsCsosn)) ||
  nfSaida?.documentoDevolucaoFornecedor
    ? true
    : false;

// const icmsProprioDeducaoSt = (produto) => {
//   const aliquota =
//     produto?.aliquotaIcmsCredito ??
//     produto?.tributosIcmsAliquota ??
//     produto?.aliquotaIcms ??
//     0;
//   return ((produto?.subtotal ?? 0) * aliquota) / 100;
// };

const baseCalculoIbs = (item) => {
  if (item?.tributosIbsBaseCalculo) {
    return arredondarValorTributo(item.tributosIbsBaseCalculo);
  }
  const subTotal =
    item?.valor * (item?.quantidade ?? 1) +
    (item?.frete ?? 0) +
    (item?.despesas ?? 0) -
    (item?.desconto ?? 0);
  const totalImpostos =
    (item?.tributosIcmsValor ?? 0) +
    (item?.tributosIpiValor ?? 0) +
    (item?.tributosPisValor ?? 0) +
    (item?.tributosCofinsValor ?? 0);
  return arredondarValorTributo(subTotal - totalImpostos);
};

const valorIbsItem = (item, aliquota, aliquotaRed, aliquotaDeferimento) => {
  const aliquotaEfet = (aliquota ?? 0) * (1 - (aliquotaRed ?? 0) / 100);
  const valor = arredondarValorTributo(
    (baseCalculoIbs(item) * aliquotaEfet) / 100,
  );
  const valorDeferimento = arredondarValorTributo(
    (valor * (aliquotaDeferimento ?? 0)) / 100,
  );
  return arredondarValorTributo(valor - valorDeferimento);
};

const somarValoresIbs = (nfSaidaItens, valorItem) =>
  arredondarValorTributo(
    nfSaidaItens.reduce(
      (acumulador, itemAtual) => acumulador + valorItem(itemAtual),
      0,
    ),
  );

const nfSaidaTotalTributos = {
  calculaBaseIcms: (produto, nfSaida) => {
    if (produto?.tributosIcmsBaseCalculoValor) {
      return produto?.tributosIcmsBaseCalculoValor;
    }
    if (
      (produto?.calculaIcms && produto?.tributosIcmsCsosn === "900") ||
      nfSaida?.documentoDevolucaoFornecedor
    ) {
      if (produto?.tributosIcmsBaseCalculoPercentualReducao) {
        return (
          produto?.subtotal -
          (produto?.subtotal *
            produto?.tributosIcmsBaseCalculoPercentualReducao) /
            100
        );
      } else {
        return produto?.subtotal;
      }
    } else {
      return 0;
    }
  },
  calculaBaseIcmsSt: (produto, nfSaida) => {
    if (produto?.impostoIcmsStBase) {
      return produto.impostoIcmsStBase;
    }
    if (temSubstituicao(produto, nfSaida)) {
      const frete = produto?.freteNaBaseSt ? (produto?.frete ?? 0) : 0;
      const despesas = produto?.despesaNaBaseSt ? (produto?.despesas ?? 0) : 0;
      const desconto = produto?.descontoNaBaseSt ? (produto?.desconto ?? 0) : 0;
      const subtotal = produto?.subtotal + frete + despesas - desconto;
    
      const subtotalComIpi =
        subtotal +
        (subtotal * (produto?.tributosIpiAliquota || 0)) / 100;
      const total = parseFloat(
        (subtotalComIpi + (subtotalComIpi * produto.aliquotaMva) / 100).toFixed(
          2,
        ),
      );
      if (produto?.impostoIcmsStReducao) {
        return total - (total * produto?.impostoIcmsStReducao) / 100;
      } else {
        return total;
      }
    } else {
      return 0;
    }
  },
  calculaBaseIpi: (produto, nfSaida) => {
    if (produto?.tributosIpiBaseCalculoValor) {
      return produto?.tributosIpiBaseCalculoValor;
    }
    if (
      (produto?.calculaIcms && produto?.tributosIcmsCsosn === "900") ||
      nfSaida?.documentoDevolucaoFornecedor
    ) {
      return produto?.subtotal;
    } else {
      return "0";
    }
  },
  calculaValorIcms: (produto, nfSaida) => {
    if (produto?.tributosIcmsValor && nfSaida?.id) {
      return produto?.tributosIcmsValor;
    }
    if (
      (produto?.calculaIcms && produto?.tributosIcmsCsosn === "900") ||
      nfSaida?.documentoDevolucaoFornecedor
    ) {
      if (produto?.tributosIcmsBaseCalculoPercentualReducao) {
        return (
          ((produto?.subtotal -
            (produto?.subtotal *
              produto?.tributosIcmsBaseCalculoPercentualReducao) /
              100) *
            (produto?.tributosIcmsAliquota || 0)) /
          100
        );
      } else {
        return (produto?.subtotal * (produto?.tributosIcmsAliquota || 0)) / 100;
      }
    } else {
      return 0;
    }
  },
  calculaValorIcmsSt: (produto, nfSaida) => {
    if (produto?.impostoIcmsSt && nfSaida.id) {
      return produto.impostoIcmsSt;
    }
    if (temSubstituicao(produto, nfSaida)) {
      const frete = produto?.freteNaBaseSt ? (produto?.frete ?? 0) : 0;
      const despesas = produto?.despesaNaBaseSt ? (produto?.despesas ?? 0) : 0;
      const desconto = produto?.descontoNaBaseSt ? (produto?.desconto ?? 0) : 0;
      const subtotal = produto?.subtotal + frete + despesas - desconto;
      
      const icmsTotalSt =
        (subtotal * (produto?.impostoIcmsStAliquota || 0)) / 100;
      // const icmsProprioDeducao = icmsProprioDeducaoSt(produto);
      // return Math.max(icmsTotalSt - icmsProprioDeducao, 0);
      return Math.max(icmsTotalSt, 0);
    } else {
      return 0;
    }
  },
  calculaValorIpi: (produto, nfSaida) => {
    if (produto?.tributosIpiValor && nfSaida.id) {
      return produto?.tributosIpiValor;
    }
    if (
      (produto?.calculaIpi && produto?.tributosIpiCsosn === "900") ||
      nfSaida?.documentoDevolucaoFornecedor
    ) {
      return (produto?.subtotal * (produto?.tributosIpiAliquota || 0)) / 100;
    } else {
      return "0";
    }
  },
  totalBaseIcms: (id, nfSaidaItens, nfSaida) => {
    if (id) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        return acumulador + itemAtual.tributosIcmsBaseCalculoValor;
      }, 0);
    } else if (nfSaida?.documentoDevolucaoFornecedor) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const baseCalculo = itemAtual.tributosIcmsBaseCalculoValor ?? 0;
        return acumulador + baseCalculo;
      }, 0);
    } else {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const subTotal = itemAtual?.valor * (itemAtual?.quantidade ?? 1);
        if (itemAtual?.tributosIcmsCsosn) {
          if (
            itemAtual.tributosIcmsCsosn.includes("900") &&
            itemAtual?.calculaIcms
          ) {
            const baseCalculo =
              subTotal -
              (subTotal *
                (itemAtual.tributosIcmsBaseCalculoPercentualReducao ?? 0)) /
                100;
            return acumulador + parseFloat(baseCalculo);
          }
        }
        return acumulador;
      }, 0);
    }
  },
  totalValorIcms: (id, nfSaidaItens, nfSaida) => {
    if (id) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        return acumulador + itemAtual.tributosIcmsValor;
      }, 0);
    } else if (nfSaida?.documentoDevolucaoFornecedor) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const baseCalculo = itemAtual.tributosIcmsBaseCalculoValor ?? 0;
        const valorIcms =
          baseCalculo * ((itemAtual?.tributosIcmsAliquota ?? 0) / 100);
        return acumulador + parseFloat(valorIcms);
      }, 0);
    } else {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const subTotal = itemAtual?.valor * (itemAtual?.quantidade ?? 1);
        if (itemAtual?.tributosIcmsCsosn) {
          if (
            itemAtual.tributosIcmsCsosn.includes("900") &&
            itemAtual?.calculaIcms
          ) {
            const baseCalculo =
              subTotal -
              (subTotal * itemAtual.tributosIcmsBaseCalculoPercentualReducao ||
                0);
            const valorIcms =
              baseCalculo * ((itemAtual?.tributosIcmsAliquota ?? 0) / 100);
            return acumulador + parseFloat(valorIcms);
          }
        }
        return acumulador;
      }, 0);
    }
  },
  totalBaseIcmsSt: (id, nfSaidaItens, nfSaida) => {
    if (id) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        return acumulador + itemAtual.impostoIcmsStBase;
      }, 0);
    }
    return nfSaidaItens.reduce((acumulador, itemAtual) => {
      return (
        acumulador + nfSaidaTotalTributos.calculaBaseIcmsSt(itemAtual, nfSaida)
      );
    }, 0);
  },
  totalValorIcmsSt: (id, nfSaidaItens, nfSaida) => {
    if (id) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        return acumulador + itemAtual.impostoIcmsSt;
      }, 0);
    }
    return nfSaidaItens.reduce((acumulador, itemAtual) => {
      return (
        acumulador + nfSaidaTotalTributos.calculaValorIcmsSt(itemAtual, nfSaida)
      );
    }, 0);
  },
  totalValorIpi: (id, nfSaidaItens, devolucao) => {
    if (id) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        return acumulador + itemAtual.tributosIpiValor;
      }, 0);
    } else if (devolucao) {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const baseCalculo = itemAtual.tributosIpiBaseCalculoValor ?? 0;
        const valorIpi =
          baseCalculo * (itemAtual?.tributosIpiAliquota / 100 ?? 0);
        return acumulador + parseFloat(valorIpi);
      }, 0);
    } else {
      return nfSaidaItens.reduce((acumulador, itemAtual) => {
        const subTotal =
          itemAtual?.valor * (itemAtual?.quantidade ?? 1) +
          (itemAtual.frete ?? 0) +
          (itemAtual.despesas ?? 0) -
          (itemAtual.desconto ?? 0);
        const valorIpi = subTotal * (itemAtual?.tributosIpiAliquota ?? 0 / 100);
        return acumulador + parseFloat(valorIpi);
      }, 0);
    }
  },
  totalValorIbsUf: (id, nfSaidaItens) => {
    if (id) {
      return somarValoresIbs(nfSaidaItens, (itemAtual) =>
        arredondarValorTributo(itemAtual.tributosIbsUfValor ?? 0),
      );
    }
    return somarValoresIbs(nfSaidaItens, (itemAtual) =>
      valorIbsItem(
        itemAtual,
        itemAtual.tributosIbsAliquotaUf,
        itemAtual.tributosIbsAliquotaRedUf,
        itemAtual.aliquotaDeferimentoUfIbs,
      ),
    );
  },
  totalValorIbsMun: (id, nfSaidaItens) => {
    if (id) {
      return somarValoresIbs(nfSaidaItens, (itemAtual) =>
        arredondarValorTributo(itemAtual.tributosIbsMunValor ?? 0),
      );
    }
    return somarValoresIbs(nfSaidaItens, (itemAtual) =>
      valorIbsItem(
        itemAtual,
        itemAtual.tributosIbsAliquotaMun,
        itemAtual.tributosIbsAliquotaRedMun,
        itemAtual.aliquotaDeferimentoMunIbs,
      ),
    );
  },
  totalValorCbs: (id, nfSaidaItens) => {
    if (id) {
      return somarValoresIbs(nfSaidaItens, (itemAtual) =>
        arredondarValorTributo(itemAtual.tributosCbsValor ?? 0),
      );
    }
    return somarValoresIbs(nfSaidaItens, (itemAtual) =>
      valorIbsItem(
        itemAtual,
        itemAtual.tributosIbsAliquotaCbs,
        itemAtual.tributosIbsAliquotaRedCbs,
        itemAtual.aliquotaDeferimentoCbs,
      ),
    );
  },
};

export default nfSaidaTotalTributos;
